
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './Pages/Login/LoginPage';
import DefaultLayout from './Components/DefaultLayout';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const storedLogin = localStorage.getItem('isLoggedIn');
    setIsLoggedIn(storedLogin === 'true');
  }, []);

  const handleLogin = () => {
    localStorage.setItem('isLoggedIn', 'true');
    setIsLoggedIn(true);
  };

  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
        <Route path="/*" element={<DefaultLayout />} />
        
         
      </Routes>
    </Router>
  );
};

export default App;
















// import React, { useState } from 'react';
// import { BrowserRouter as Router } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import LoginPage from './Pages/Login/LoginPage';
// import DefaultLayout from './Components/DefaultLayout';

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // must be false to show LoginPage

//   return (
//     <Router>
//       <Toaster position="top-right" reverseOrder={false} />
//       {isLoggedIn ? (
//         <DefaultLayout />
//       ) : (
//         <LoginPage onLogin={() => setIsLoggedIn(true)} />
//       )}
//     </Router>
//   );
// };

// export default App;
